'use strict';

module.exports = function (ngModule) {
  ngModule.service('Messenger', ["$rootScope", "$log", function ($rootScope, $log) {
    var userData = {};

    this.setMessenger = function(data) {
      userData = {};

      if (_.has(data, 'title') && _.isObject(data.title)) {
        userData['title'] = data.title;
      }

      if (_.has(data, 'btn') && _.isArray(data.btn)) {
        userData['btn'] = data.btn;
      }

      if (_.has(data, 'message') && _.isArray(data.message)) {
        userData['message'] = data.message;
      }
    }

    this.getMessenger = function () {
      return userData;
    }

    this.isEmpty = function () {
      return _.isEmpty(userData);
    }
  }]);
};



//////////////////
// WEBPACK FOOTER
// ./js/services/messenger.js
// module id = 58
// module chunks = 0